// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2ddv2","inputDescription":"styles_inputDescription__2O2eI"};